import HostFreeAreaService from '@/services/free-area/host-free-area'

export class OrderHistoryFreeArea extends HostFreeAreaService {
  protected get freeAreaPaths() {
    return [
      'OrderHistoryHeader',
    ]
  }
}
